import * as React from "react"
const SvgCheckCircleFilledMini = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 16 16"
    {...props}
  >
    <path d="M7.038 8.87 5.85 7.682a.81.81 0 0 0-.599-.24.813.813 0 0 0-.833.838q.004.36.244.599l1.75 1.75q.27.265.628.265.36 0 .625-.266l3.625-3.625q.24-.24.24-.594a.8.8 0 0 0-.24-.594.81.81 0 0 0-.598-.24q-.36 0-.599.24zM8 14.987a6.8 6.8 0 0 1-2.732-.55 7 7 0 0 1-2.215-1.49 7 7 0 0 1-1.49-2.215A6.8 6.8 0 0 1 1.012 8q0-1.459.55-2.732a7 7 0 0 1 1.49-2.215 7 7 0 0 1 2.215-1.49A6.8 6.8 0 0 1 8 1.012q1.458 0 2.732.55a7 7 0 0 1 2.214 1.49 7 7 0 0 1 1.492 2.215q.549 1.274.549 2.732t-.55 2.732a7 7 0 0 1-1.49 2.214 7 7 0 0 1-2.215 1.492q-1.274.549-2.732.549" />
  </svg>
)
// eslint-disable-next-line import/no-default-export
export default SvgCheckCircleFilledMini
